module.exports = __webpack_public_path__ + "img/Send-gift-bro.7ab5adb7.png";